var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-parallax',{staticClass:"hidden-sm-and-down pa-0 test",attrs:{"dark":"","src":_vm.divider.url,"height":_vm.getHeight}})}
var staticRenderFns = []

export { render, staticRenderFns }